import {Mapper} from '@s-ui/domain'

export class LastDetailsViewedItemJsonToLastDetailsViewedItemValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Function} lastDetailsViewedItemValueObjectFactory
   */
  constructor({lastDetailsViewedItemValueObjectFactory}) {
    super({lastDetailsViewedItemValueObjectFactory})
    this._lastDetailsViewedItemValueObjectFactory = lastDetailsViewedItemValueObjectFactory
  }

  map = id => this._lastDetailsViewedItemValueObjectFactory(id)
}
